import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = ["button"]

  async copy() {
    if (!this.hasTextValue || !navigator.clipboard) {
      return
    }

    try {
      await navigator.clipboard.writeText(this.textValue)
      this.showFeedback("Copiado")
    } catch (_error) {
      this.showFeedback("Erro")
    }
  }

  showFeedback(message) {
    if (!this.hasButtonTarget) {
      return
    }

    clearTimeout(this.feedbackTimeout)

    const originalLabel = this.buttonTarget.dataset.originalLabel || this.buttonTarget.textContent
    this.buttonTarget.dataset.originalLabel = originalLabel
    this.buttonTarget.textContent = message

    this.feedbackTimeout = setTimeout(() => {
      this.buttonTarget.textContent = originalLabel
    }, 1500)
  }
}
